<!--
 * @Descripttion: 
 * @Author: chenxt
 * @Date: 2025-03-14 14:42:03
-->
<template>
    <div id="home">
    </div>
</template>
  
<script>
import {getOpenId, checkIfCanLogin, logonByTicket} from '@/api/baseMsg';
import { Toast } from 'vant';
import { setToken, removeToken } from '../../utils/auth';
import {
    loading
} from '@/common/loading';
export default {
    name: "home",
    data(){
        return{
            code: this.$route.query.code?this.$route.query.code:"",
        }
    },
    created() {
        this.init()
        // this.checkIfLogin(123456789)
    },
    methods: {
        init() {
            // 1.调用getOpenId获取openid存入session里
            // 2.调用checkIfCanLogin判断是否能登陆-------能登录则调用logonByTicket自动登录/不能登录则跳转登录页
            // loading(true)
            getOpenId({code: this.code}).then(res=> {
                if(res.code == 200) {
                    // 存openid
                    sessionStorage.setItem('wxOpenId', res.data)
                    this.checkIfLogin(res.data)
                }else {
                    this.$router.push({ path: '/login'});
                }
            })
        },
        checkIfLogin(openId) {
            checkIfCanLogin({openId: openId}).then(res=> {
                if(res.code == 200) {
                    this.loginTick(res.data)
                }else {
                    this.$router.push({ path: '/login'});
                }
            })
        },
        loginTick(ticket) {
            logonByTicket({ticket: ticket}).then(res=> {
                if(res.code == 200) {
                    this.$store.commit('login/SET_LOGINTYPE', 1);
                    setToken(res.data.token);
                    if (res.data.ifSystem == 1) {
                        this.$router.push({ path: '/' });
                    } else {
                        this.$router.push({ path: '/jiagecaijiTB/jiagecaiji' });
                    }
                }else {
                    this.$router.push({ path: '/login'});
                }
            })
        }
    }
}
</script>
  
<style lang="scss" scoped>
#home {
    height: 100vh;
    width:100vw;
    background: url('~@/assets/floor.png') no-repeat;
    background-size: 100% 100%;
    position: relative;
}
</style>
  
  